

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import actualidadModule from '@/store/actualidad'
import formulariosModule from '@/store/formularios'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';
import validatorJp from '@/validator/jp';

import messages from '@/translations';

import {langdetector} from '@/langdetector';

//SET IDIOMA
let lang = langdetector();


export const store = new Vuex.Store({
  state :{
    language: lang,
    server : 'https://back.ajusa.es',
    homeLaunched : false,
    ghostMenu : false
  },
  actions :{
    changeLanguage : ({commit}, lang) => {
      return new Promise((resolve, reject) => {
        commit('setLanguage', lang);
        switch (lang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
          case "ja":
          Validator.localize('ja', validatorJp);
          break;
         
        }
        resolve(lang);
      });
    },
    setInitHome : ({commit}) => {
      commit('initHome');
    },
    changeLaunched : ({commit}) => {
      commit('toggleLaunched');
    },
    changeGhostMenu : ({commit},value) => {
      commit('toggleGhostMenu',value);
    },
    
  },
  getters : {
    getLanguage : state => state.language,
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    },
    getrawtexts : state => messages,
    isLaunchedHome : state => state.homeLaunched,
    ghostMenu : state => state.ghostMenu,

  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    },
    toggleLaunched(state){
      state.homeLaunched = !state.homeLaunched;
    },
    initHome(state){
      state.homeLaunched = false
    },
    toggleGhostMenu(state, value){
      if(!!!value){
        state.ghostMenu = !state.ghostMenu;
      }else{
        state.ghostMenu = value;
      }
    }
  },
  modules :{
    actualidadModule,
    formulariosModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js